import React, { FC } from 'react';
import { Col, Row } from 'react-bootstrap';
import Accordion from '../../../components/Accordion/Accordion';
import SimpleModal from '../../../components/modals/SimpleModal/SimpleModal';
import { useReferenceData } from '../../../hooks/reduxHooks';
import { DigitalOrderResourcesData } from '../../../services/digitalCodesService';
import { numberWithCommas } from '../../../utils/currencyUtils';

interface PurposeDetailsModalProps {
	show: boolean;
	purposes: DigitalOrderResourcesData['purposes'][number][];
	selectedPlatform?: string;
	onClose: () => void;
}
const PurposeDetailsModal: FC<PurposeDetailsModalProps> = ({
	show,
	purposes,
	selectedPlatform,
	onClose,
}) => {
	const platforms = useReferenceData('platforms');
	const platformsInUse = Array.from(
		new Set(
			purposes.flatMap(purpose => purpose.platform_code)
		)
	);
	const getPurposeName = (purpose: string, purpose_type: string, price_type_code: string) => {
		if (purpose_type === 'CODE_IN_BOX') {
			if (price_type_code === 'WHOLESALE') {
				return purpose + ' (Wholesale)';
			} else {
				return purpose + ' (Download Size)';
			}
		} else {
			return purpose;
		}
	};

	return (
		<SimpleModal show={show} size="lg" title="Purpose Descriptions" closeModal={onClose}>
			<Accordion defaultActiveKey={selectedPlatform}>
				{platformsInUse.map((platform, index) => {
					const purposeList = purposes.filter((purpose) =>
						purpose.platform_code.includes(platform),
					);
					return (
						<Accordion.Item eventKey={platform} key={platform}>
							<Accordion.Heading>{platforms?.find(({ platform_code }) => platform_code === platform)?.platform_name}</Accordion.Heading>
							{purposeList.flatMap((purpose) => {
								const isCodeInBox = purpose.purpose_type === 'CODE_IN_BOX';
								return purpose.purpose_details && Array.isArray(purpose.purpose_details)
									? purpose.purpose_details
										.filter((purpose_detail: any) => {
											if (!isCodeInBox) return true;
											if (platform === 'POT') {
												return purpose_detail.product_type === 'BEE';
											}
											return purpose_detail.product_type === platform;
										})
										.map((purpose_detail: any) => (
											<div key={'purpose' + purpose.purpose_id}>
												<p>
													<b>{getPurposeName(purpose.purpose, purpose.purpose_type, purpose_detail.price_type_code)}</b>
													<br /> {purpose.purpose_description}{' '}
												</p>
												<Row className="mb-3">
													<Col xs={4} md={3}>
														Minimum order:
														<br />
														{(purpose_detail.min_number_of_codes &&
															numberWithCommas(purpose_detail.min_number_of_codes)) ?? (
															<>&mdash;</>
														)}
													</Col>
													<Col xs={4} md={3}>
														Maximum order:
														<br />
														{(purpose_detail.max_number_of_codes &&
															numberWithCommas(purpose_detail.max_number_of_codes)) ?? (
															<>&mdash;</>
														)}
													</Col>
													<Col xs={4} md={4}>
														{(purpose_detail.code_batch_increments > 1 && (
															<>
																Code quantity in batches of:
																<br />
																{numberWithCommas(
																	purpose_detail.code_batch_increments,
																)}
															</>
														)) || <span>&nbsp;</span>}{' '}
													</Col>
												</Row>
												<Row>
													<Col xs={12}>
														<p>Price type: {purpose_detail.price_type}</p>
													</Col>
												</Row>
											</div>
										))
									: [];
							})}
						</Accordion.Item>
					);
				})}
			</Accordion>
		</SimpleModal>
	);
};

export default PurposeDetailsModal;
